import { AnyAction } from "redux";
import { ReSwitchState } from "../../../../../models/state";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const reducer = (state = {}, action: AnyAction): ReSwitchState => {
    if (action.type === fulfilled(AT.CHECKOUT_EMPTY_CART)) {
        return {};
    } else {
        return state;
    }
};

export default reducer;
